// extracted by mini-css-extract-plugin
module.exports = {"container":"SampleList_container__B4V0P","table":"SampleList_table__2sdeY","noSamples":"SampleList_noSamples__24X9d"};